import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormInput } from 'elements/Inputs/FormInput/';
import { StyledLabel } from 'elements/Label/Label';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { StyleDropdown } from './AsFoundTestWorkshop.styled';

import { selectAsFoundTestWorkshopSectionData } from './AsFoundTestWorkshop.data';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    }
}));

const AsFoundTestWorkshopSection = (props) => {
    const { selectedTag, formData, changeHandler, formName, isFormReadOnly, userRole } = props;
    const classes = useStyles();
    const formDropdownInput = (field) => field.isDropdown ? (
        <StyleDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                width={field.width}
                labelWidth={field.labelWidth}
                readOnly={isFormReadOnly || field.readOnly}
                direction={field.direction}
                isDisabled={field.isDisabled}
                marginLeft={field.marginLeft}
                marginRight={field.marginRight}
                height={field.height}
                inputTextAlign={field.inputTextAlign}
                marginTop={field.marginTop}
                paddingPlaceholder={field.paddingPlaceholder}
                arrowMarginTop={field.arrowMarginTop}
            />
        </StyleDropdown>
    )
    : (
        <FormInput
            id={field.key}
            name={field.key}
            label={field.label}
            value={field.value}
            isRequired={field.isRequired}
            isCalculated={field.isCalculated}
            isCalculatedNew={field.isCalculatedNew}
            isDisabled={field.isDisabled}
            readOnly={field.readOnly || isFormReadOnly}
            handleChange={changeHandler}
            direction={field.direction}
            textAlign={field.textAlign}
            type={field.type}
            padding={field.padding}
            width={field.width}
            labelWidth={field.labelWidth}
            marginLeft={field.marginLeft}
            maxLength={field.maxLength}
            marginRight={field.marginRight}
            fontSize={field.fontSize}
            marginBottom={field.marginBottom}
            marginTop={field.marginTop}
            borderRight={field.borderRight}
            height={field.height}
            borderBottom={field.borderBottom}
            borderTop={field.borderTop}
            borderLeft={field.borderLeft}
            isLabelNew={field.isLabelNew}
            inputMarginRight={field.inputMarginRight}
            isLabelBold={field.isLabelBold}
            userRole={userRole}
            fontWeight={field.fontWeight}
        />
    );
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectAsFoundTestWorkshopSectionData(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                        ? (
                                            <StyledLabel
                                                id={field.key}
                                                label={field.label}
                                                fontWeight={field.fontWeight}
                                                textAlign={field.textAlign}
                                                labelWidth={field.labelWidth}
                                                padding={field.padding}
                                                marginLeft={field.marginLeft}
                                                fontSize={field.fontSize}
                                            >
                                                {field.label}
                                            </StyledLabel>
                                        )
                                        : formDropdownInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AsFoundTestWorkshopSection);

AsFoundTestWorkshopSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
